<template>
    <div>
        <NavBar />
        <ProjectList showDrawer="false" :id="id" v-if="loadingProjectList" />
        <main>
            <v-row class="map_edit_container">
                <v-col class="mb-30" cols="7">
                    <ProjectEdit :id="id" />
                </v-col>
                <v-col cols="5">
                    <DropBox />
                </v-col>
                <v-col cols="12" class="layers_block">
                    <LayerTable />
                </v-col>
            </v-row>
        </main>
    </div>
</template>

<script>
import NavBar       from "../NavBar";
import ProjectList  from "../PLComponents/ProjectList";
import ProjectEdit  from "../PLComponents/ProjectEdit";
import DropBox      from "../PLComponents/DropBox";
import LayerTable   from "../PLComponents/LayerTable";

export default {
    name: "ProjectsList",
    props: ['id'],
    components:{
        NavBar,
        ProjectList,
        ProjectEdit,
        DropBox,
        LayerTable
    },
    data () {
        return {
            loadingProjectList: false
        }
    },
    computed: {
        projects () {
            return this.$store.getters.projects;
        },
        projectsLoaded(){
            return this.$store.getters.projectsLoaded
        }
    },
    watch: {
        projects: function (){
            if (this.projectsLoaded && this.projects.length == 0){
                this.$router.push('/');
            }
        }
    },
    created() {
        this.$vuetify.theme.dark = true;
        if (!this.projectsLoaded){
            this.$store.dispatch('getProjects')
            .then(() => {
                if(this.projects.length == 0){
                    this.$router.push('/');
                }
                else{
                    this.loadingProjectList = true;
                }
            })
            .catch(() => {})
        }
        else{
            if(this.projects.length == 0){
                this.$router.push('/');
            }
            else{
                this.loadingProjectList = true;
            }
        }
    }
};
</script>
